import { OptionFormTypes } from '../../services/filtering/filter-form-render-service/option-form-types';
import { mapDateTimeFilters } from '../../containers/orders-filter-bar-container/date-time-filter-mapper';
import { mapCollectionFilters } from '../../containers/orders-filter-bar-container/collection-filter-mapper';
import { orderFilterOptions } from '../../containers/orders-filter-bar-container/filter-options/options';
import ShipmentsFilterOptions from '../../pages/shipping-page/shipping-filter-bar-container/filter-options/options';

export const filterBar = 'filterBar';

// BTC -- TODO -- using this in src\pages\shipping-page\shipping-filter-bar-container\index.js, remove this comment when this is either mode-agnostic or a shipping-specific version exists
export const mapOrdersFilterBarFiltersToContext = (newlyAppliedFilters, source, useShipmentsFilters = false) => {
  const AllFilterOptions = useShipmentsFilters ? ShipmentsFilterOptions : orderFilterOptions;
  const newFilters = newlyAppliedFilters.reduce((acc, filter) => {
    const { filterById, type, criterionArgumentValue, criterionOperatorValue } = filter;
    if (
      type === OptionFormTypes.TYPE_ORDER_DATE_COMPARISON ||
      type === OptionFormTypes.TYPE_DATE_COMPARISON ||
      type === OptionFormTypes.TYPE_DATE_COMPARISON_SHIPMENTS
    ) {
      const dateFilter = mapDateTimeFilters(filter);
      return [...acc, { ...dateFilter, source: source || filterBar }];
    }
    if (type === OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER || type === OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER_OR_BLANK) {
      const collectionFilter = mapCollectionFilters(filter);
      const { id, value, operator } = collectionFilter;
      const matchedFilter = AllFilterOptions.find((f) => f.id === filterById);
      const currentFilterIndex = acc.findIndex((f) => f.id === filterById);
      const consolidatedFilters =
        currentFilterIndex !== -1 && matchedFilter.expectsArgumentAsArray
          ? [
              ...acc.slice(0, currentFilterIndex),
              ...acc.slice(currentFilterIndex + 1),
              {
                id,
                value: [
                  ...(Array.isArray(acc[currentFilterIndex].value) ? acc[currentFilterIndex].value : [acc[currentFilterIndex].value]),
                  ...(Array.isArray(value) ? value : [value]),
                ],
                operator,
                source: source || filterBar,
              },
            ]
          : [...acc, { ...collectionFilter, source: source || filterBar }];
      return consolidatedFilters;
    }
    const valueAsArrayIfNeeded =
      type !== OptionFormTypes.TYPE_BOOLEAN && !Array.isArray(criterionArgumentValue) ? [criterionArgumentValue] : criterionArgumentValue; // Added because there's an edge case where modifying a saved filter can cause issues
    if (type === OptionFormTypes.TYPE_CHECKLIST) {
      return [
        ...acc,
        {
          id: filterById,
          value: valueAsArrayIfNeeded,
          operator: { value: criterionOperatorValue || true },
          source: source || filterBar,
        },
      ];
    }
    return [
      ...acc,
      {
        id: filterById,
        value: valueAsArrayIfNeeded,
        operator: { value: criterionOperatorValue },
        source: source || filterBar,
      },
    ];
  }, []);
  return newFilters;
};
